{
	"clientInvoices": {
		"email": "Email",
		"issuedAt": "Date et heure",
		"links": "Liens",
		"loading": "Chargement...",
		"name": "Consommateurs",
		"noInvoices": "Il n'y a pas de factures émis à afficher",
		"onSubmitEmailForm": "Envoi de factures par email",
		"openCoupon": "Ouvrir coupon",
		"openPdf": "Ouvrir PDF",
		"send": "Envoyer",
		"somethingWrong": "Quelque chose n'a pas fonctionné",
		"submitButton": "Émettre facture",
		"title": "Factures de {{clientName}}",
		"updatePage": "Veuillez actualiser la page et réessayer"
	},
	"clientTransactions": {
		"buyers": "Acheteurs",
		"date": "Heure",
		"product": "Produits",
		"refunded": "Remboursé ?",
		"sellerName": "Vendeur",
		"title": "Extrait du client {{clientName}}'"
	}
}
